import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import CurrencySelector from '../../common/CurrencySelector';
import style from '../ProviderComparisonWidget.module.less';

import AmountInput from './AmountInput';

// FIXME This randomly chooses a currency that's not the same one as "selected"?, it should be deterministic ideally
const getTopCurrency = (selectedCurrency) => {
  const topCurrencies = ['GBP', 'EUR', 'USD', 'AUD'];
  const index = Math.floor(Math.random() * (topCurrencies.length - 1));
  return topCurrencies.filter((c) => c !== selectedCurrency)[index];
};

const getRouteAttributesToUpdate = (type, selectedCurrency, currencyToCheck) => {
  const attributesToUpdate = { [type]: selectedCurrency };
  if (selectedCurrency === currencyToCheck) {
    const currencyRoute = {
      sourceCurrency: 'targetCurrency',
      targetCurrency: 'sourceCurrency',
    };
    // eslint-disable-next-line fp/no-mutation
    attributesToUpdate[currencyRoute[type]] = getTopCurrency(selectedCurrency);
  }
  return attributesToUpdate;
};

const Options = ({
  sourceCurrency,
  targetCurrency,
  availableTargetCurrencies,
  onRouteChange,
  amount,
  onAmountChange,
}) => {
  const updateCurrenciesRoute = (type, selectedCurrency) => {
    const route = {
      sourceCurrency: () => getRouteAttributesToUpdate(type, selectedCurrency, targetCurrency),
      targetCurrency: () => getRouteAttributesToUpdate(type, selectedCurrency, sourceCurrency),
    };

    const attributesToUpdate = route[type]();
    onRouteChange({ ...attributesToUpdate });
    return attributesToUpdate;
  };

  const onCurrencyChange = (type) => (selectedCurrencyProfile) => {
    updateCurrenciesRoute(type, selectedCurrencyProfile.code);
  };

  return (
    <div className={style.OptionsForm}>
      <span className={`${style.OptionsForm__sourceAmountAndCurrency} ${style.OptionsForm__text}`}>
        <FormattedMessage id="send" />
      </span>
      <span className={style.OptionsForm__sourceAmountAndCurrency}>
        <AmountInput
          amount={amount}
          onAmountChange={onAmountChange}
          currencyCode={sourceCurrency}
        />
      </span>
      <span className={style.OptionsForm__sourceAmountAndCurrency__currency}>
        <CurrencySelector
          type="sourceCurrency"
          currencyCode={sourceCurrency}
          style={style}
          onSelectChange={onCurrencyChange}
          data-testid="sourceCurrencySelector"
        />
      </span>
      {/* <span className={style.OptionsForm__sourceAmountAndCurrencyAlternat} />*/}

      <span className={style.OptionsForm__text}>
        <FormattedMessage id="to-label" />
      </span>
      <CurrencySelector
        type="targetCurrency"
        currencyCode={targetCurrency}
        style={style}
        onSelectChange={onCurrencyChange}
        availableCurrencies={availableTargetCurrencies}
        disabled={(availableTargetCurrencies || [])?.length === 0}
        data-testid="targetCurrencySelector"
      />
    </div>
  );
};

Options.propTypes = {
  sourceCurrency: PropTypes.string.isRequired,
  targetCurrency: PropTypes.string.isRequired,
  availableTargetCurrencies: PropTypes.arrayOf(PropTypes.string),
  onRouteChange: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  onAmountChange: PropTypes.func.isRequired,
};

Options.defaultProps = {
  availableTargetCurrencies: null,
};

export default Options;
